// Global Instructions Rule Applied!
import React from 'react'

/**
 * Displays companies as blue rounded badges with company names
 * @param {object} props
 * @param {Array<any>} [props.companies] - Company objects (or bare ids); the badge shows `label` or `name`, and the id is read from `value` / `id` / `data.id` unless `getCompanyId` is given
 * @param {(company: any, companyId: string) => void} [props.onCompanyClick] - Callback when a badge is clicked; omit it and the badges are not clickable
 * @param {(company: any) => string | null | undefined} [props.getCompanyId] - Overrides how a company's id is read
 */
export const CompanyBadges = ({ companies = [], onCompanyClick, getCompanyId }) => {
  if (!companies || companies.length === 0) {
    return '-'
  }

  const handleCompanyClick = (company, e) => {
    if (onCompanyClick) {
      e.stopPropagation()
      e.preventDefault()
      const companyId = getCompanyId
        ? getCompanyId(company)
        : company?.value || company?.id || company?.data?.id || null
      if (companyId) {
        onCompanyClick(company, companyId)
      }
    }
  }

  return (
    <div className='flex items-center flex-wrap gap-1'>
      {companies.map((company, index) => {
        const isClickable = !!onCompanyClick
        const companyId = getCompanyId
          ? getCompanyId(company)
          : company?.value || company?.id || company?.data?.id || null

        return (
          <div
            key={index}
            onClick={isClickable && companyId ? (e) => handleCompanyClick(company, e) : undefined}
            className={`inline-flex items-center justify-center rounded-full text-black text-sm pl-1 pr-1 bg-blue-100 border border-blue-400 whitespace-nowrap ${
              isClickable && companyId ? 'cursor-pointer hover:bg-blue-200 hover:border-blue-500' : ''
            }`}
          >
            {company?.label || company?.name || 'Unknown'}
          </div>
        )
      })}
    </div>
  )
}
